
import { SUPABASE_URL } from '@/integrations/supabase/config';

export const getDynamicProxyUrl = (): string => {
  // Используем централизованную конфигурацию вместо жестко прописанного URL
  return SUPABASE_URL;
};

export const buildProxyUrl = (endpoint: string): string => {
  const baseUrl = getDynamicProxyUrl();
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${baseUrl}/${cleanEndpoint}`;
};

// Добавляем отсутствующие экспорты для обратной совместимости
export interface DynamicServicesConfig {
  [key: string]: any;
}

export const loadDynamicConfig = async (): Promise<any> => {
  // Заглушка для динамической конфигурации
  return {};
};

export const createDynamicServicesConfig = (config: any): DynamicServicesConfig => {
  // Заглушка для создания динамической конфигурации сервисов
  return config || {};
};

export const clearConfigCache = (): void => {
  // Заглушка для очистки кэша конфигурации
  console.log('Кэш конфигурации очищен');
};

console.log('✅ Динамический прокси использует централизованную конфигурацию:', SUPABASE_URL);
